var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.TabsLayout,[_c('ElTabPane',{attrs:{"name":"mediataglist","label":"媒体标签列表"}}),_c('ElTabPane',{attrs:{"name":"mediataglog","label":"素材绑定进度"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }